import { render, staticRenderFns } from "./BasicDataDetail.vue?vue&type=template&id=aa83f4c8&scoped=true"
import script from "./BasicDataDetail.vue?vue&type=script&lang=js"
export * from "./BasicDataDetail.vue?vue&type=script&lang=js"
import style0 from "./BasicDataDetail.vue?vue&type=style&index=0&id=aa83f4c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa83f4c8",
  null
  
)

export default component.exports